import { List } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

/**
 * Action for add products to ProductList
 */
export const addProductsToList = createAction(
  '[ProductList] Add products to product List',
  props<{ list: List; products: Product[]; onlyStateUpdate?: boolean }>(),
);

/**
 * Action for delete a products from ProductList
 */
export const deleteProductsFromList = createAction(
  '[ProductList] Delete product from product List',
  props<{ list: List; products: Product[] }>(),
);

export const addNextAvailableVariantToList = createAction(
  '[ProductList] Add next available variant to List',
  props<{ list?: List; product: Product }>(),
);

export const addNextAvailableVariantToListSuccess = createAction(
  '[ProductList] Add next available variant to List Success',
  props<{ list: List; product: Product }>(),
);

export const addNextAvailableVariantToListFailure = createAction(
  '[ProductList] Add next available variant to List Failure',
  props<{ list: List; product: Product }>(),
);
